import { has } from 'lodash'
import React, { useContext } from 'react'
import { BookInfo } from '../../contexts/menuContext'

const MobileMenuMainLink = ({ items, activeMenu, changeActiveMenu }) => {
  // const [active, setActive] = useState(false)
  const [book, setBook, , setPage] = useContext(BookInfo)
  if (has(items, 'link')) {
    return (
      <li key={items.key} className="bookreader-nav-item">
        <span>
          <a
            data-reference={items.key}
            href={items.link}
            role="tab"
            target="_blank"
          >
            {items.name}
          </a>
        </span>
      </li>
    )
  }

  return (
    <li className={`bookreader-nav-item ${activeMenu === items.key && 'open'}`} >
      <span onClick={() => {
        setPage(null)
        if (items.key === activeMenu) {
          changeActiveMenu(false)
        } else {
          changeActiveMenu(items.key)
        }
        setBook({ ...book, page_type: items.key })
      }}
      >
        {items.name}
      </span>
      {items.content}
    </li>
  )
}

export default MobileMenuMainLink
